export default class CaptchaCatcher {
  static defaults = {
    captchaBadge: 'grecaptcha-badge',
    captcha: '.g-recaptcha',
    captchaBox: '.g-recaptcha-response',
  };

  constructor() {
    this.options = {
      ...CaptchaCatcher.defaults,
    };

    this.bind();

    window.addEventListener('load', () => {
      if (document.body.id === 'account' || document.body.id === 'create-account') {
        this.doBadge();
      }
      if (document.body.id === 'challenge') {
        this.doBadge();
        this.doForms();
      }
    });
  }

  bind() {
    this.doBadge = this.doBadge.bind(this);
    this.doForms = this.doForms.bind(this);
  }

  doBadge() {
    this.badge = document.querySelector(`.${this.options.captchaBadge}`);
    if (this.badge) {
      const box = this.badge.querySelector(this.options.captchaBox);
      this.amendElement(box);
    }
  }

  doForms() {
    grecaptcha.ready(() => {
      const boxes = document.querySelectorAll(this.options.captchaBox);
      if (boxes.length) {
        boxes.forEach(box => this.amendElement(box));
      }
    });
  }

  amendElement(el) {
    el.setAttribute('aria-label', 'google recaptcha');
  }
}
